import Page from 'components/ui/Page'
import React from 'react'
import { useParams } from 'react-router-dom'
import FlexTable from '../FlexTable/FlexTable'
import SalesLeadView from './SalesLeadView'

const SalesLeadViewPage = () => {
    const { id } = useParams()
    return (
        <Page title={`Sales Lead #${id}`}>
            <SalesLeadView id={id} />
        </Page>
    )
}

SalesLeadViewPage.propTypes = {}

export default SalesLeadViewPage
